var DEFAULT_API_BASE = '/api/v1';
var DEFAULT_SLUG = 'psy';
var isLocalHost = function (hostname) {
    return /^(localhost|127\.0\.0\.1)$/i.test(hostname);
};
var resolveMode = function (hostname, explicitDomain) {
    var raw = String(__CSIO_MODE__ || '')
        .trim()
        .toLowerCase();
    if (raw === 'slug' || raw === 'domain') {
        return raw;
    }
    if (explicitDomain) {
        return 'domain';
    }
    if (isLocalHost(hostname)) {
        return 'slug';
    }
    return 'domain';
};
export var getCsioConfig = function () {
    var hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    var apiBase = String(__CSIO_API_BASE__ || DEFAULT_API_BASE).replace(/\/$/, '');
    var mediaOrigin = String(__CSIO_MEDIA_ORIGIN__ || '').replace(/\/$/, '');
    var slug = String(__CSIO_SITE_SLUG__ || DEFAULT_SLUG);
    var explicitDomain = String(__CSIO_DOMAIN__ || '').trim();
    var mode = resolveMode(hostname, explicitDomain);
    return {
        apiBase: apiBase,
        mode: mode,
        slug: slug,
        domain: explicitDomain || hostname,
        mediaOrigin: mediaOrigin,
    };
};
